/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect, createRef, useImperativeHandle, useState } from 'react'
import { useGLTF, PerspectiveCamera, useAnimations } from '@react-three/drei'
import * as THREE from 'three'
import { Outline, EffectComposer } from '@react-three/postprocessing'
//import { BlendFunction, Resizer, KernelSize } from 'postprocessing'

const playActions = (actions) => {
  Object.entries(actions).forEach((item, idx) => {
      
    item[1].stop()
    item[1].setLoop(THREE.LoopOnce, 1)
    item[1].timeScale = 1
    item[1].clampWhenFinished = true
    item[1].loop = true
    item[1].play()
    //console.log(item[1]._clip.name)
    
  })
}

const playRevert = (actions) => {
  Object.entries(actions).forEach((item, idx) => {

    item[1].stop()
    item[1].timeScale = -1
    item[1].play()
    //console.log(item[1]._clip.name)
    
  })

}


const ToSelect = {
  "mixture_regulator": {
    name: "Regulacja mieszanki",
    description: ""
  },
  "float_chamber_bolt": {
    name: "Śruba komory pływakowej",
    description: ""
  },
  "spire":{
    name: "Iglica",
    description: ""
  },
  "body_dome": {
    name: "Korpus",
    description: ""
  },
  "float_cover": {
    name: "Pokrywa komory pływakowej",
    description: ""
  },
  "float": {
    name: "Pływak",
    description: ""
  },
  "float_body": {
    name: "Komora pływakowa",
    description: ""
  },
  "throttle":{
    name: "Przepustnica",
    description: ""
  },
  "throttle_spring": {
    name: "Spręzyna przepustnicy",
    description: ""
  },
  "throttle_adjustment": {
    name: "Regulacja przepustnicy",
    description: ""
  },
}

const Model = React.forwardRef(({...props}, ref) => {

  
  const group = useRef()
  //const ref = useRef()
  const { nodes, materials, animations } = useGLTF('./models/G20_Anim_v3.glb')
  const { actions, mixer } = useAnimations(animations, group)

  
  

    const [objectRefs] = useState({
      "mixture_regulator": createRef(), //ok
      "float_chamber_bolt": createRef(), //ok
      "spire": createRef(), //ok
      "body_dome": createRef(), //ok
      "float_cover": createRef(), //ok
      "float": createRef(), //ok
      "float_body": createRef(),//ok
      "throttle": createRef(),//ok
      "throttle_spring": createRef(),//ok
      "throttle_adjustment": createRef() // ok
    })
    
  
  const [selected, setSelected] = useState()
 
  
  useImperativeHandle(ref, ()=> ({
    play: () => {playActions(actions);  },
    assembly: () => {playRevert(actions); },
    selectItem: (key) => {  
      
      if(key===null) {
        setSelected(null)
        return;
      }
      
      if(objectRefs[key].current) {

      
        setSelected(() => objectRefs[key]);
      
    } 
  }
  }), [])

  
  useEffect(() => {

    // setSelected()

    //console.log(meshRef);

    // ref.current = (action = 'PLAY') => {

    //   if(action==='PLAY') {
    //     alert("Play");
    //   } 
    //   if(action==='ASSEMBLY') {
    //     alert("revert");
    //   } 


    // }
  
   //ref.current.play = () => {alert("Play"); playActions(actions);  }
    //ref.current.assembly = () => {alert("revert"); playRevert(actions, mixer) }
    // playRevert(actions, mixer)
    console.log("PLAY")
    
    //const len = Object.entries(actions).length-1
    const len = 3
    //console.log(Object.entries(actions));

    mixer.addEventListener("finished", (e) => {

      if(e.action._clip.name==="Spring.005Action") {
        console.log("Its end")
        props.endCallback()
      }

    })  
    
    //playActions(actions)
    


  }, [])

  const intensity = 0.5

  return (<React.Fragment>
    
    <group ref={group} {...props} scale={0.35} dispose={null}>
      <group>
        <group position={[-4.43, 2.34, -5.22]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[3.43, 2.34, -5.22]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[3.43, 2.34, 5.21]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[-4.82, 2.34, 5.21]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[-4.43, -6.63, -7.08]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[3.43, -6.63, -7.08]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[-4.43, -6.63, 10.53]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[3.43, -6.63, 10.53]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[-4.43, 10.02, -5.22]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[3.43, 10.02, -5.22]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[3.43, 10.02, 5.21]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[-4.82, 10.02, 5.21]}>
          <pointLight intensity={intensity} decay={2} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group position={[-0.23, 0.43, 39.22]} rotation={[Math.PI / 2, 0, 0]}>
          <PerspectiveCamera  far={1000} near={0.2} fov={36.01} rotation={[-Math.PI / 2, 0, 0]} />
        </group>
        <group name="Podkladka003" position={[-0.51, 0.61, 2.19]} scale={0.08} />
        <mesh ref={objectRefs.float_body} name="Zbiornik005" geometry={nodes.Zbiornik005.geometry} material={materials.M_Metall_Dust} position={[1.31, -2, 0.24]} />
        <mesh ref={objectRefs.float_cover} name="Dekiel_Zbiornika005" geometry={nodes.Dekiel_Zbiornika005.geometry} material={materials.M_Metall_Dust} position={[1.24, 0.67, 0.24]}>
          <mesh  name="Dekiel_Zbiornika011" geometry={nodes.Dekiel_Zbiornika011.geometry} material={materials['M_MIedz.001']} position={[-0.57, 0.44, 0]} />
        </mesh>
        <mesh name="Uszczelka_XL001" geometry={nodes.Uszczelka_XL001.geometry} material={materials.M_Uszczelka} position={[1.25, 0.28, 0.24]} />
        <mesh name="Bolt005" geometry={nodes.Bolt005.geometry} material={materials.M_Bolt} position={[1.31, -0.02, 1.64]} scale={0.07} />
        <mesh name="Podkladka004" geometry={nodes.Podkladka004.geometry} material={materials.M_Bolt} position={[1.31, 0.61, 1.64]} scale={0.08} />
        <mesh name="Bolt006" geometry={nodes.Bolt006.geometry} material={materials.M_Bolt} position={[1.31, 0.36, -1.16]} scale={0.07} />
        <mesh name="Podkladka005" geometry={nodes.Podkladka005.geometry} material={materials.M_Bolt} position={[1.31, 0.6, -1.16]} scale={0.08} />
        <mesh ref={objectRefs.float_chamber_bolt} name="Sruba_Komory_Paliwa001" geometry={nodes.Sruba_Komory_Paliwa001.geometry} material={materials['M_Metall_Dust.001']} position={[-1.02, -3.35, 0.24]} scale={0.99} />
        <mesh ref={objectRefs.body_dome} name="Gaznik_Korpus001" geometry={nodes.Gaznik_Korpus001.geometry} material={materials['M_Metall_Dust.001']} position={[-1.02, 0.08, 0.24]}>
          <mesh name="Circle025" geometry={nodes.Circle025.geometry} material={materials['M_Metall_Dust.001']} position={[0, -2.47, 0]} />
        </mesh>
        <mesh ref={objectRefs.throttle} name="Retopo_Cross_Joint009" geometry={nodes.Retopo_Cross_Joint009.geometry} material={materials['M_Metall_Dust.002']} position={[-1.02, 0.29, 0.24]} rotation={[-Math.PI, 0, -Math.PI]}>
          <mesh ref={objectRefs.spire} name="Retopo_Cross_Joint010" geometry={nodes.Retopo_Cross_Joint010.geometry} material={materials.M_MIedz_2} position={[0, 0.4, -0.01]} />
        </mesh>
        <mesh name="Gaznik_Dekielek001" geometry={nodes.Gaznik_Dekielek001.geometry} material={materials['M_Metall_Dust.001']} position={[-1.02, 2.65, 0.23]} scale={1.09}>
          <mesh name="Nut003" geometry={nodes.Nut003.geometry} material={materials.M_MIedz_2} position={[0, 1.83, 0]} rotation={[0, 0.46, 0]} scale={0.07} />
          <mesh geometry={nodes.Nut002.geometry} material={materials.M_MIedz} position={[0, 1.88, 0]} scale={0.07} />
        </mesh>
        <mesh ref={objectRefs.throttle_spring} name="Spring002" geometry={nodes.Spring002.geometry} material={materials.M_Spring} position={[-1.02, 0.72, 0.24]} />
        <mesh ref={objectRefs.float} name="Circle026" geometry={nodes.Circle026.geometry} material={materials.M_Plywak} position={[1.3, -1.77, 0.25]} scale={1.21} />
        <mesh name="Uszczelka_M_1001" geometry={nodes.Uszczelka_M_1001.geometry} material={materials['M_Metall_Dust.001']} position={[-1.02, -2.46, 0.24]} />
        <mesh name="Uszczelka_M_2001" geometry={nodes.Uszczelka_M_2001.geometry} material={materials['M_Metall_Dust.001']} position={[-1.02, -3.48, 0.24]} />
        <mesh ref={objectRefs.mixture_regulator} name="Bolt007" geometry={nodes.Bolt007.geometry} material={materials.M_MIedz_2} position={[-2.07, 0.19, 0.26]} />
        <mesh ref={objectRefs.throttle_adjustment} name="Bolt008" geometry={nodes.Bolt008.geometry} material={materials.M_MIedz_2} position={[-1.47, -0.8, -0.67]} />
        <mesh name="Spring004" geometry={nodes.Spring004.geometry} material={materials['M_Metall_Dust.001']} position={[-1.54, -0.8, -0.67]} />
        <mesh name="Spring005" geometry={nodes.Spring005.geometry} material={materials.M_MIedz} position={[-2.07, 0.19, 0.26]} scale={0.92} />
      </group>
    </group>


        <EffectComposer multisampling={0} autoClear={false}>
            <Outline selection={selected} visibleEdgeColor="white" hiddenEdgeColor="white"  edgeStrength={100}  />
        </EffectComposer>
     </React.Fragment>
  ) 

})

export default Model
export {ToSelect}

useGLTF.preload('./models/G20_Anim_v2.glb')
